export enum PROPERTY_HASH_MAP {
  calculator = 'calculator',
  financing = 'financing',
  rentInfo = 'rent-info',
  volatility = 'volatility',
  market = 'market',
  realEstate = 'real-estate',
  offeringDetails = 'offering-details',
  financialBreakdown = 'financial-breakdown',
  commonQuestions = 'common-questions',
  reviews = 'reviews',
}
